'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _lodashUniq = require('lodash.uniq');

var _lodashUniq2 = _interopRequireDefault(_lodashUniq);

var _cleanUrls = require('./clean-urls');

var _cleanUrls2 = _interopRequireDefault(_cleanUrls);

var replaceParamsWithWildcard = function replaceParamsWithWildcard(route) {
  return route.replace(/:[a-zA-Z]+/g, '*');
};

exports['default'] = (0, _lodashUniq2['default'])(_cleanUrls2['default'].map(replaceParamsWithWildcard));
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./~/@seek/seek-jobs-seo/build/routes.js
 ** module id = 503
 ** module chunks = 0
 **/